
export abstract class Config {

  private static initFinished = false

  private static config: any = {}

  public static async init() {
    if ( this.initFinished ) {
      return
    }

    const response = await fetch('/config.json', { cache: 'no-store' })
    const data = await response.json()

    if ( !data ) {
      console.error('Configuration file not found or empty');
    }

    this.config = data

    this.initFinished = true
  }

  public static getConfig() {
    return this.config
  }

}
